module.exports = __webpack_public_path__ + "static/logo_cropped-c494ddd8c711ea4abcee47d7bb38b9c6.png";